export enum KEYCODES {
  TAB = 'Tab',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SPACE = 'Space',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  M = 'KeyM',
}
